import styled from '@emotion/styled'
import { calcRem } from '../../../__styling/style-functions/calc-rem'
import { themedValue } from '../../../__styling/themed-value'

export const StyledSidebarHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    background: theme.colors.background.secondary,
    justifyContent: themedValue(theme, {
        thewest: 'flex-end',
        perthnow: 'flex-start',
        fallback: undefined,
    }),

    padding: themedValue(theme, {
        thewest: calcRem(22, 0),
        perthnow: calcRem(10, 0, 0, 20),
        fallback: undefined,
    }),
    '& svg': {
        height: themedValue(theme, {
            thewest: 30,
            perthnow: 36,
            fallback: undefined,
        }),
        width: themedValue(theme, {
            thewest: 137,
            perthnow: 167,
            fallback: undefined,
        }),
    },
}))
export const StyledLogoWrap = styled('div')((props) => ({
    width: calcRem(137),
    height: calcRem(30),
}))
